
import React, { useState, useEffect, useImperativeHandle, forwardRef } from 'react';
import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";
import Preloader from '../../../general/Preloader';
import ReactHtmlParser from 'react-html-parser';

const PayPal = forwardRef((props, ref) => {
    const token = document.querySelector("[name='csrf-token']").content;
    const [isLoaded, setIsLoaded] = useState(true);
    const [currency, setCurrencyCode] = useState(props.price.currency.code);
    const [value, setValue] = useState(props.prices.paypal);
    const [message, setMessage] = useState({
        title: "",
        show: false
    });

    useEffect(() => {
        loadData();
    }, []);

    const loadData = () => {
        fetch(`/user/get_currency_values/${props.customerData.price_id}/${props.customerData.discount_code_id}`, {
            method: 'GET', // or 'PUT'
            headers: {
                "X-CSRF-Token": token,
                "Content-Type": "application/json"
            }
        })
        .then(response => response.json())
        .then(data => {
            console.log("datadatadatadatadatadata", data);
            setValue(data.currency.value)
            setCurrencyCode(data.currency.currency_code)
            setMessage(data.message)
            setIsLoaded(false);
        });
    }

    const handleClick = () => {
        setMessage({
            ...message,
            show: !message.show
        })
    }

    return (
        <React.Fragment>        
            {!isLoaded ? (
                <React.Fragment>
                    {message.show ? (
                        <React.Fragment>
                            <div className="card">
                                <div className="card-body">
                                    <h4 className='text-center'>{ReactHtmlParser(message.title)}</h4>
                                    <div className='col-md-12 text-center mt-2'>
                                        <button
                                            className='btn btn-success text-white'
                                            onClick={() => handleClick()}
                                        >
                                            Continuar con el pago
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </React.Fragment>
                    ) : (
                        <PayPalScriptProvider options={{ "client-id": props.client_paypal }}>
                            <PayPalButtons
                                createOrder={(data, actions) => {
                                    return actions.order.create({
                                        intent: "CAPTURE",
                                        purchase_units: [
                                            { 
                                                amount: { 
                                                    currency_code: currency,
                                                    value: value 
                                                },

                                                reference_id: `${props.reference}, ${props.customerData.user_platform_id}, ${props.customerData.price_id}, ${props.customerData.affiliate_id ? props.customerData.affiliate_id : null }, ${props.customerData.discount_code_id ? props.customerData.discount_code_id : null}`,
                                            }
                                        ],
                                    });
                                }}
                                onApprove={(data, actions) => {
                                    return actions.order.capture().then((details) => {
                                        if(details.status == "COMPLETED"){
                                            props.toogleTab("payment_completed")
                                        }
                                    });
                                }}
                            />
                        </PayPalScriptProvider>
                    )}

                </React.Fragment>
            ) : (
                <div className="text-center">
                    <Preloader/>
                </div>
            )}
        </React.Fragment>
    );
});


export default PayPal;